import { Reveal } from "@/components/Reveal";
import BlueprintOverlay from "@/components/BlueprintOverlay";
import { useLang } from "@/context/LangContext";
import Seo from "@/components/Seo";

const STEP_NUMS = ["01", "02", "03", "04"];

export default function Process() {
  const { t } = useLang();
  const steps = t("process.steps");
  return (
    <div data-testid="process-page" className="relative">
      <Seo title={t("seo.processTitle")} description={t("seo.process")} />
      <section className="relative overflow-hidden border-b border-bone/10">
        <BlueprintOverlay dimLabel={t("process.dimLabel")} stamp="DWG-PROCESS-FR-000" />
        <div className="relative mx-auto max-w-7xl px-6 pb-20 pt-40 sm:px-10 lg:px-16">
          <Reveal>
            <p className="eyebrow">{t("process.eyebrow")}</p>
            <h1 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-tight text-bone sm:text-5xl lg:text-6xl">
              {t("process.titleA")}<br />{t("process.titleB")}
            </h1>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-bone-dim/80 sm:text-base">
              {t("process.intro")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-6 py-24 sm:px-10 lg:py-32">
        <div className="relative space-y-20">
          <div className="absolute bottom-8 left-[27px] top-8 hidden w-px bg-bone/10 sm:block" />
          {steps.map((s, i) => (
            <Reveal key={STEP_NUMS[i]} delay={i * 0.08}>
              <div className="relative grid gap-6 sm:grid-cols-[56px_1fr]">
                <div className="hidden sm:block">
                  <span className="sticky top-32 flex h-14 w-14 items-center justify-center border border-brass/40 bg-ink font-mono text-sm text-brass">
                    {s.n}
                  </span>
                </div>
                <div className="border border-bone/10 bg-ink-2 p-8 transition-colors duration-500 hover:border-brass/30 lg:p-12">
                  <p className="font-mono text-[10px] tracking-[0.35em] text-brass sm:hidden">{t("process.phase")} {STEP_NUMS[i]}</p>
                  <h2 className="mt-2 font-serif text-3xl font-light text-bone sm:mt-0 sm:text-4xl">{s.title}</h2>
                  <p className="mt-5 max-w-2xl text-sm leading-relaxed text-bone-dim/85 sm:text-base">{s.text}</p>
                  <p className="mt-6 border-t border-bone/10 pt-4 font-mono text-[9px] tracking-[0.25em] text-bone-muted">
                    {s.tags}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
